// CTISItemValidator.js
export const validateItem = (item, existingItems = []) => {
  const errors = {};

  if (!item.id) errors.id = "ID is required.";
  if (existingItems.some(i => i.id === item.id && i.uuid !== item.uuid)) {
    errors.id = "ID must be unique.";
  }

  if (!item.item_name) errors.item_name = "Item name is required.";
  if (!item.ctis_section) errors.ctis_section = "Section is required.";

  // Coherent Publishable Logic
  if (item.public_version_required && !item.publishable) {
    errors.publishable = "If a public version is required, the item must be publishable.";
  }

  return {
    isValid: Object.keys(errors).length === 0,
    errors
  };
};